module.exports = __webpack_public_path__ + "img/238.d46ea6b2.jpg";